import React, { useState, useEffect, useRef } from 'react';
import {
  VegaFlex,
  VegaForm,
  VegaInput,
  VegaSelectionTileGroup,
  VegaSelectionTile,
  VegaButton,
  VegaCheckbox
} from "@heartlandone/vega-react";

const THIRD_STEP = 2;

function StepThree({ isEdit = false, form = {}, currentStep, onPreviousClick = () => {}, onNextClick = () => {} }) {
  const _isShow = () => currentStep === THIRD_STEP;
  const [isOnlineActivityText, setIsOnlineActivityText] = useState('venue');
  const [city, setCity] = useState('');
  const [address, setAddress] = useState('');
  const [meetingUrl, setMeetingURL] = useState('');
  const [meetingID, setMeetingID] = useState('');
  const [passcode, setPasscode] = useState('');
  const [canGoNext, setCanGoNext] = useState(false);
  const meetingUrlInputRef = useRef();


  useEffect(() => {
    setCanGoNext(
      isOnlineActivityText === 'online'
        ? meetingUrlInputRef.current?.isValid !== false
        : address?.trim().length > 0 & city?.trim().length > 0
    );
  }, [isOnlineActivityText, city, address, meetingUrl]);

  useEffect(() => {
    if (isEdit) {
      setIsOnlineActivityText(form.isOnlineActivity ? 'online' : 'venue');
      setMeetingURL(form.meetingUrl);
      setMeetingID(form.meetingID);
      setPasscode(form.passcode);
      setCity(form.city || '');
      setAddress(form.address || '');
    }
  // eslint-disable-next-line
  }, [form]);
  

  const handleSelectionChange = (event) => {
    const value = event.target.value;
    setIsOnlineActivityText(value);
  };

  const URLFormatRule = {
    canEvaluate(input, status) {
      return typeof input === "string" && !status.disabled && status.visible;
    },

    shouldShowError(
      status
    ) {
      return (
        !status.disabled &&
        status.visible &&
        (status.touched || status.modified)
      );
    },

    evaluate: (input) => {
      const trimmedInput = input.trim();
    
      if (trimmedInput === '') {
        return { isValid: true, message: '' };
      }

      const urlPattern = /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$/i;
      const isValid = urlPattern.test(trimmedInput);
      return { isValid, message: isValid ? '' : 'Please enter a valid URL' };
    },
  };

  return (
    <div className={`m-t-32${_isShow() ? "" : " display-none"}`}>
      <div className="form-step-title">Location</div>
      <div className="content-wrapper m-t-24">
        <VegaFlex direction="col" gap="size-24">
          <VegaCheckbox data-vega-form={'isOnlineActivity'} style={{ display: 'none'}} value={isOnlineActivityText === 'online'}/>
          <VegaSelectionTileGroup
            value={isOnlineActivityText}
            layout="horizontal"
            data-vega-form={"isOnlineActivityText"}
            onVegaChange={handleSelectionChange}
          >
            <VegaFlex gap="size-24" flex={1}>
                <VegaSelectionTile
                style={{ width: '31%' }}
                value="venue"
                title="Venue"
                prefixIcon="far fa-location-dot"
                note="For activities with venues"
                data-vega-form={"activityType"}
              />
              <VegaSelectionTile
                style={{ width: '31%' }}
                value="online"
                title="Online Activity"
                prefixIcon="far fa-presentation-screen"
                note="For activities with online"
                data-vega-form={"activityType"}
              />
            </VegaFlex>
          </VegaSelectionTileGroup>

          {isOnlineActivityText === "venue" && (
            <VegaForm>
              <VegaFlex alignItems={"flex-start"} gap="size-24">
                <VegaInput
                  style={{ width: '46.3%' }}
                  size="small"
                  gap="size-24"
                  required={true}
                  value={city}
                  label="City"
                  maxLength={10}
                  data-vega-form={"city"}
                  onVegaChange={(e) => setCity(e.detail)}
                />
                <VegaInput
                  size="small"
                  gap="size-24"
                  label="Address"
                  value={address}
                  onVegaChange={(e) => setAddress(e.detail)}
                  required
                  maxLength={200}
                  data-vega-form={"address"}
                />
              </VegaFlex>
            </VegaForm>
          )}

          {isOnlineActivityText === 'online' && (
            <>
              <VegaForm>
                <VegaInput
                  ref={meetingUrlInputRef} 
                  label="Meeting URL"
                  size="small"
                  value={meetingUrl}
                  validationRules={[URLFormatRule]}
                  onVegaChange={(e) => setMeetingURL(e.detail)}
                  data-vega-form={"meetingUrl"}
                  maxLength={1000}
                  autoValidation={true}
                />
              </VegaForm>
              <VegaForm>
                <VegaInput
                  label="Meeting ID"
                  size="small"
                  type="text"
                  value={meetingID}
                  onVegaChange={(e) => setMeetingID(e.detail)}
                  data-vega-form={"meetingID"}
                  maxLength={50}
                />
              </VegaForm>
              <VegaForm>
                <VegaInput
                  label="Passcode"
                  size="small"
                  value={passcode}
                  onVegaChange={(e) => setPasscode(e.detail)}
                  data-vega-form={"passcode"}
                  maxLength={50}
                />
              </VegaForm>
            </>
          )}
        </VegaFlex>
        <VegaFlex justifyContent="space-between" className="m-t-40 p-t-20 p-b-48 border-none" style={{ marginBottom: -24 }}>
          <VegaButton variant="secondary" label="Previous" onVegaClick={() => onPreviousClick('Location')} />
          <VegaButton label="Next" disabled={!canGoNext} onVegaClick={() => onNextClick('Location')} />
        </VegaFlex>
      </div>
    </div>
  );
}

export default StepThree;